import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import TabsWrap from './components/TabsWrap'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Tabs extends Component {
    static propTypes = {
        activeIndex: PropTypes.number.isRequired,
        defaultIndex: PropTypes.number,
        id: PropTypes.string.isRequired,
        inline: PropTypes.bool,
        level: PropTypes.string.isRequired,
        sharedContent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                title: PropTypes.string.isRequired,
                subtitle: PropTypes.string,
                content: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
                counter: PropTypes.shape({
                    left: PropTypes.oneOfType([
                        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        PropTypes.shape({
                            count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                            color: PropTypes.string,
                        }),
                    ]),
                    right: PropTypes.oneOfType([
                        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        PropTypes.shape({
                            count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                            color: PropTypes.string,
                        }),
                    ]),
                }),
                disabled: PropTypes.bool,
                locked: PropTypes.bool,
                showNewBanner: PropTypes.bool,
                onClick: PropTypes.func,
            })
        ),
    }

    static defaultProps = {
        defaultIndex: 0,
        inline: false,
        sharedContent: null,
        tabs: [],
    }

    renderContent = () => {
        const { activeIndex, defaultIndex, sharedContent, tabs } = this.props

        const functionParams = {
            index: activeIndex,
            defaultIndex,
            tabId: _.get(tabs, `${activeIndex}.tabId`, undefined),
        }

        const tabContent = _.get(tabs, `${activeIndex}.content`, null)
        if (tabContent) return _.isFunction(tabContent) ? tabContent(functionParams) : tabContent

        return _.isFunction(sharedContent) ? sharedContent(functionParams) : sharedContent || null
    }

    render() {
        const { id, tabs, inline, activeIndex, level } = this.props

        return (
            <div className={'general-tabs'}>
                <div className={'general-tabs-tabs'}>
                    <TabsWrap id={id} level={level} tabs={tabs} inline={inline} activeIndex={activeIndex} />
                </div>
                <div className={'general-tabs-content'}>{this.renderContent()}</div>
            </div>
        )
    }
}
